<nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <ul class="navbar-nav">
      	<li class="nav-item">
        	<a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      	</li>
      	<li class="nav-item d-none d-sm-inline-block">
        	<a routerLink="home" class="nav-link">Home</a>
      	</li>
    </ul>

    <ul class="navbar-nav ml-auto">
      	<li class="nav-item">
        	<p class="nav-link" style="cursor:pointer"  (click)="logout()"  href="#">登出</p>
      	</li>
    </ul>
</nav>
